const appinfo = {
  title: 'Alaya'
};

export default appinfo;
